export default __webpack_public_path__ + "/img/001-sk-banner.d54f28db.jpg";